import { isMaskedEmail } from './isMaskedEmail';

const isCleartextEmail = (email?: string | null): email is string => !!email && !isMaskedEmail(email);

export default isCleartextEmail;
